<template>
  <nav
    class="flex border-b border-background-fg/5 bg-background py-1"
    aria-label="Breadcrumb"
  >
    <ol
      role="list"
      class="mx-auto flex w-full flex-wrap items-center justify-start space-x-4"
    >
      <li
        :class="[
          'flex h-[36px] items-center',
          breadcrumbs.length === 0 ? 'w-full' : 'w-auto',
        ]"
      >
        <div
          :class="[
            'flex items-center',
            breadcrumbs.length === 0 ? 'w-full' : 'w-auto',
          ]"
        >
          <div class="flex items-center">
            <RouterLink
              :to="{ name: 'fullTill' }"
              class="ml-4 text-sm font-medium text-background-fg/70 hover:text-background-fg"
            >
              <IconHome
                class="size-5 shrink-0"
                aria-hidden="true"
              />
              <span class="sr-only">Home</span>
            </RouterLink>
          </div>

          <SearchInputCompact
            v-if="breadcrumbs.length === 0"
            :model-value="props.search"
            class="w-full"
            @update:model-value="
              emit('update:search', $event)
            "
          />
        </div>
      </li>

      <template
        v-for="breadcrumb in breadcrumbs"
        :key="breadcrumb.label"
      >
        <li class="flex">
          <div class="flex items-center">
            <IconChevronRight
              class="size-5 shrink-0 text-gray-400"
              aria-hidden="true"
            />
            <RouterLink
              :to="breadcrumb.to"
              class="ml-4 text-sm font-medium text-background-fg/70 hover:text-background-fg"
              >{{ breadcrumb.label }}</RouterLink
            >
          </div>
        </li>
      </template>
    </ol>
  </nav>
</template>

<script setup lang="ts">
const props = defineProps<{
  search: string
}>()

const { breadcrumbs } = useBreadcrumbs()

const emit = defineEmits<{
  (event: "update:search", value: string): void
}>()
</script>
